import { isImmutable, Map, Record } from 'immutable'
import _ from 'lodash'

export const createDataTableId = (module, id, block = null, namespace = null) => {
    const blockPart = block ? `_${block}` : ''
    const namespacePart = namespace ? `_${namespace}` : ''
    return `${module}_${id}${blockPart}${namespacePart}_data_table`
}

export const createDataTableRegex = (module, id = null, block = null, namespace = null) => {
    const idPart = id ? `_${id}` : '.*'
    const blockPart = block ? `_${block}` : '.*'
    const namespacePart = namespace ? `_${namespace}` : '.*'
    return new RegExp(`^${module}${idPart}${blockPart}${namespacePart}_data_table$`)
}

export const createFilterTableId = (module, id, block = null, namespace = null) => {
    const blockPart = block ? `_${block}` : ''
    const namespacePart = namespace ? `_${namespace}` : ''
    return `${module}_${id}${blockPart}${namespacePart}_filter_table`
}

export const createFilterTableRegex = (module, id = null, block = null, namespace = null) => {
    const idPart = id ? `_${id}` : '.*'
    const blockPart = block ? `_${block}` : '.*'
    const namespacePart = namespace ? `_${namespace}` : '.*'
    return new RegExp(`^${module}${idPart}${blockPart}${namespacePart}_filter_table`)
}

export const createListTableId = (module, id, block = null, namespace = null) => {
    const blockPart = block ? `_${block}` : ''
    const namespacePart = namespace ? `_${namespace}` : ''
    return `${module}_${id}${blockPart}${namespacePart}_list_table`
}

export const createListTableRegex = (module, id = null, block = null, namespace = null) => {
    const idPart = id ? `_${id}` : '.*'
    const blockPart = block ? `_${block}` : '.*'
    const namespacePart = namespace ? `_${namespace}` : '.*'
    return new RegExp(`^${module}${idPart}${blockPart}${namespacePart}_list_table$`)
}

export const createChartId = (module, id, block = null, namespace = null) => {
    const blockPart = block ? `_${block}` : ''
    const namespacePart = namespace ? `_${namespace}` : ''
    return `${module}_${id}${blockPart}${namespacePart}_chart`
}

export const createChartRegex = (module, id = null, block = null, namespace = null) => {
    const idPart = id ? `_${id}` : '.*'
    const blockPart = block ? `_${block}` : '.*'
    const namespacePart = namespace ? `_${namespace}` : '.*'
    return new RegExp(`^${module}${idPart}${blockPart}${namespacePart}_chart$`)
}

export const createTabsRegex = (module, id = null, block = null, namespace = null) => {
    const idPart = id ? `_${id}` : '.*'
    const blockPart = block ? `_${block}` : '.*'
    const namespacePart = namespace ? `_${namespace}` : '.*'
    return new RegExp(`^${module}${idPart}${blockPart}${namespacePart}_tabs$`)
}

export const mergeDeepUpdates = (oldValue, newValue, path = []) => {
    if (_.isNil(oldValue)) return oldValue

    let updatedValue = oldValue

    if (!isImmutable(newValue)) return updatedValue.setIn(path, newValue)

    newValue.forEach((value, key) => {
        updatedValue = mergeDeepUpdates(updatedValue, value, [...path, key])
    })

    return updatedValue
}

export const EntityRecord = Record({
    activity: Map({
        active: false,
        endDate: Map({
            precision: '',
            value: '',
        }),
        startDate: Map({
            precision: '',
            value: '',
        }),
    }),
    country: Map({
        iso2: '',
        iso3: '',
        name: '',
    }),
    id: 0,
    indicators: Map({
        caution: 0,
        notice: 0,
        risk: 0,
    }),
    name: '',
    regNbr: '',
    type: '',
})
